import { Box, Typography } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";

const CoverageScoreLabel = ({ value, sx = {} }) => {
  const colors = useColors();
  const priorityColors = {
    High: {
      bg: colors.risk_high_bg,
      color: colors.risk_high_text,
    },
    Medium: {
      bg: colors.risk_medium_bg,
      color: colors.risk_medium_text,
    },
    Low: {
      bg: colors.risk_low_bg,
      color: colors.risk_low_text,
    },
    Compliant: {
      bg: colors.risk_minimal_bg,
      color: colors.risk_minimal_text,
    },
  };
  const getColor = (score) => {
    if (score < 20) return priorityColors.High.color;
    if (score < 30) return priorityColors.Medium.color;
    if (score < 70) return priorityColors.Low.color;
    return priorityColors.Compliant.color;
  };
  const getBgColor = (score) => {
    if (score < 20) return priorityColors.High.bg;
    if (score < 30) return priorityColors.Medium.bg;
    if (score < 70) return priorityColors.Low.bg;
    return priorityColors.Compliant.bg;
  };
  const safeValue = parseFloat(value);
  return (
    <Box
      sx={{
        backgroundColor: !isNaN(safeValue)
          ? getBgColor(value)
          : colors.grey_200,
        color: !isNaN(safeValue) ? getColor(value) : colors.secondary_text,
        py: 0.5,
        px: 1,
        borderRadius: 1,
        display: "flex",
        alignItems: "center",
        fontSize: "13px",
        fontWeight: 600,
        ...sx,
      }}
    >
      <Typography variant="caption">
        {safeValue < 0 || isNaN(safeValue) ? "N/A" : safeValue + "%"}
      </Typography>
    </Box>
  );
};

export default CoverageScoreLabel;
